import { Puzzle } from "./Game";

export const hardCodedPuzzles : Record<number, Puzzle> = {
    "1": {
        "target": "exist",
        "initialGuesses": [
            "rotor"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "2": {
        "target": "sword",
        "initialGuesses": [
            "woody"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            }
        ]
    },
    "3": {
        "target": "harsh",
        "initialGuesses": [
            "comet"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            }
        ]
    },
    "4": {
        "target": "dirty",
        "initialGuesses": [
            "triad"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "5": {
        "target": "shine",
        "initialGuesses": [
            "grave"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            }
        ]
    },
    "6": {
        "target": "front",
        "initialGuesses": [
            "await"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            }
        ]
    },
    "7": {
        "target": "final",
        "initialGuesses": [
            "crude"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            }
        ]
    },
    "8": {
        "target": "slope",
        "initialGuesses": [
            "stoop"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            }
        ]
    },
    "9": {
        "target": "store",
        "initialGuesses": [
            "stove"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            }
        ]
    },
    "10": {
        "target": "break",
        "initialGuesses": [
            "chess"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            }
        ]
    },
    "11": {
        "target": "amino",
        "initialGuesses": [
            "tribe"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            }
        ]
    },
    "12": {
        "target": "panic",
        "initialGuesses": [
            "smoky"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            }
        ]
    },
    "13": {
        "target": "wrath",
        "initialGuesses": [
            "wreck"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "14": {
        "target": "flute",
        "initialGuesses": [
            "since"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            }
        ]
    },
    "15": {
        "target": "frank",
        "initialGuesses": [
            "delay"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "16": {
        "target": "prove",
        "initialGuesses": [
            "foyer"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            }
        ]
    },
    "17": {
        "target": "teddy",
        "initialGuesses": [
            "tempo"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            }
        ]
    },
    "18": {
        "target": "vague",
        "initialGuesses": [
            "crypt"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            }
        ]
    },
    "19": {
        "target": "arbor",
        "initialGuesses": [
            "omega"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            }
        ]
    },
    "20": {
        "target": "regal",
        "initialGuesses": [
            "screw"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "21": {
        "target": "razor",
        "initialGuesses": [
            "month"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            }
        ]
    },
    "22": {
        "target": "bring",
        "initialGuesses": [
            "ideal"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            }
        ]
    },
    "23": {
        "target": "cruel",
        "initialGuesses": [
            "flash"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "24": {
        "target": "kappa",
        "initialGuesses": [
            "murky"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            }
        ]
    },
    "25": {
        "target": "wagon",
        "initialGuesses": [
            "count"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "26": {
        "target": "dairy",
        "initialGuesses": [
            "there"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            }
        ]
    },
    "27": {
        "target": "foyer",
        "initialGuesses": [
            "click"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            }
        ]
    },
    "28": {
        "target": "quite",
        "initialGuesses": [
            "white"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            }
        ]
    },
    "29": {
        "target": "skull",
        "initialGuesses": [
            "avert"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "30": {
        "target": "messy",
        "initialGuesses": [
            "table"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            }
        ]
    },
    "31": {
        "target": "title",
        "initialGuesses": [
            "bleed"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            }
        ]
    },
    "32": {
        "target": "enjoy",
        "initialGuesses": [
            "saint"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            }
        ]
    },
    "33": {
        "target": "salty",
        "initialGuesses": [
            "pearl"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            }
        ]
    },
    "34": {
        "target": "birch",
        "initialGuesses": [
            "paint"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            }
        ]
    },
    "35": {
        "target": "comma",
        "initialGuesses": [
            "petit"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            }
        ]
    },
    "36": {
        "target": "notch",
        "initialGuesses": [
            "chair"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            }
        ]
    },
    "37": {
        "target": "owner",
        "initialGuesses": [
            "count"
        ],
        "fibs": [
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            }
        ]
    },
    "38": {
        "target": "happy",
        "initialGuesses": [
            "mamma"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "39": {
        "target": "wrath",
        "initialGuesses": [
            "modal"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            }
        ]
    },
    "40": {
        "target": "stair",
        "initialGuesses": [
            "shock"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            }
        ]
    },
    "41": {
        "target": "often",
        "initialGuesses": [
            "broom"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            }
        ]
    },
    "42": {
        "target": "stern",
        "initialGuesses": [
            "tally"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "43": {
        "target": "blame",
        "initialGuesses": [
            "tonic"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            }
        ]
    },
    "44": {
        "target": "crown",
        "initialGuesses": [
            "shout"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            }
        ]
    },
    "45": {
        "target": "drunk",
        "initialGuesses": [
            "scent"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            }
        ]
    },
    "46": {
        "target": "theft",
        "initialGuesses": [
            "smart"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            }
        ]
    },
    "47": {
        "target": "block",
        "initialGuesses": [
            "adorn"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            }
        ]
    },
    "48": {
        "target": "timer",
        "initialGuesses": [
            "guest"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    },
    "49": {
        "target": "franc",
        "initialGuesses": [
            "alley"
        ],
        "fibs": [
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            }
        ]
    },
    "50": {
        "target": "jelly",
        "initialGuesses": [
            "locus"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            }
        ]
    },
    "51": {
        "target": "slope",
        "initialGuesses": [
            "chalk"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            }
        ]
    },
    "52": {
        "target": "cycle",
        "initialGuesses": [
            "folly"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            }
        ]
    },
    "53": {
        "target": "brass",
        "initialGuesses": [
            "bacon"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            }
        ]
    },
    "54": {
        "target": "lofty",
        "initialGuesses": [
            "saint"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            }
        ]
    },
    "55": {
        "target": "groom",
        "initialGuesses": [
            "sport"
        ],
        "fibs": [
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            }
        ]
    },
    "56": {
        "target": "prime",
        "initialGuesses": [
            "lover"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 1
            }
        ]
    },
    "57": {
        "target": "onset",
        "initialGuesses": [
            "hoist"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            }
        ]
    },
    "58": {
        "target": "point",
        "initialGuesses": [
            "facet"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            }
        ]
    },
    "59": {
        "target": "tense",
        "initialGuesses": [
            "focus"
        ],
        "fibs": [
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 3,
                "offset": 1
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            },
            {
                "position": 4,
                "offset": 1
            }
        ]
    },
    "60": {
        "target": "chair",
        "initialGuesses": [
            "lurid"
        ],
        "fibs": [
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 2
            },
            {
                "position": 4,
                "offset": 2
            },
            {
                "position": 2,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 2
            },
            {
                "position": 0,
                "offset": 1
            },
            {
                "position": 1,
                "offset": 1
            }
        ]
    }

};